import { createRouter, createWebHistory } from 'vue-router';

import NotFoundPage from '@/core/pages/NotFoundPage.vue';

const router = createRouter({
  history: createWebHistory(),
  scrollBehavior: () => ({ top: 0 }),
  routes: [
    {
      path: '/',
      name: 'Home',
      component: { template: '<div />' },
      beforeEnter: () => ({ name: 'Collect' }),
      meta: { layout: 'main' },
    },
    // Catch-all 404 — module routes are added before this via addRoute,
    // but Vue Router always matches the most specific record regardless of order.
    {
      path: '/:pathMatch(.*)*',
      name: 'NotFound',
      component: NotFoundPage,
      meta: { layout: 'main' },
    },
  ],
});

export default router;
